export const getProperPrescriptionDetail = (detail: string) => {
    var prescriptionDetail: string = detail;

    if (detail) {
        prescriptionDetail = detail.replace('<br/>', ', ');
    }

    return prescriptionDetail;
}